<template>
  <div>
    <div>
      <h3 class="title-color">Applicant Info</h3>
    </div>

    <div class="e-card-separator"></div>

    <div class="main-container">
      <div class="sub-container">
        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Requestor:"
            :value="permit.requestor"
            :readOnly="true"
            class="readOnlyField"
            :maxlength="250"
          />
        </div>

        <date-info
          ref="applicationDateRef"
          dateType="applicationDate"
          placeHolder="Application Date (MM/DD/YYYY):"
        />

        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            :maxlength="250"
            placeholder="PO/Reference #:"
            v-model="permit.planReviewNo"
          />
        </div>
        <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="Municipality:"
          :value="permit.municipality"
          :readOnly="true"
          class="readOnlyField"
          :maxlength="250"
        />
        </div>

        <div class="form-row-input">
          <ejs-textbox
            float-label-type="Always"
            placeholder="Permit #:"
            :value="permit.permitNo"
            :readonly="true"
            :maxlenght="250"
            class="readOnlyField"
          />
        </div>

        <div class="form-row-input" style="display: flex; flex-direction: column; gap: 10px">
          <div>Permit Applicant: *</div>
          <div style="display: flex; flex-direction: column; gap: 10px">
            <ejs-radiobutton
              ref="owner"
              name="permitApplicant"
              label="Owner"
              :checked="permit.isOwnerSameApplicant"
              @change="isSameApplicant()"
            />
            <ejs-radiobutton
              ref="contractor"
              label="Contractor"
              name="permitApplicant"
              :checked="permit.isContractorSameApplicant"
              @change="isSameApplicant()"
            />
            <ejs-radiobutton
              ref="engineer"
              label="Engineer"
              name="permitApplicant"
              :checked="permit.isEngineerSameApplicant"
              @change="isSameApplicant()"
            />
          </div>
          <label v-if="showPermitApplicantValidationError" class="e-error"
            >This field is required</label
          >
        </div>
      </div>
    </div>

    <div class="main-container">
      <address-info
        @updateAddress="updateAddress"
        @updateContactFieldDS="updateContactFieldDS"
        @updateCompanyLegalName="updateCompanyLegalName"
        :applier="applier"
        :showCountryField="true"
        :company="permit.applicantCompany"
      />
      <div class="e-card-separator"></div>
      <contact-info
        ref="applicantContactRef"
        @updateContactNumber="updateContactNumber"
        @updateContactInfo="updateContactInfo"
        :phoneRules="[requiredRule, phoneRule]"
        :emailRules="[requiredRule, emailRule]"
        :applier="applier"
        :contact="permit.applicantContact"
        :contactFieldDataSource="contactFieldDataSource"
      />
    </div>

    <div class="main-container">
      <div class="form-row-input">
        <ejs-textbox
          float-label-type="Always"
          placeholder="Development Permit Number(if applicable):"
          v-model="permit.developmentPermitNumber"
          :maxlength="250"
        />
      </div>

      <div class="form-row-input">
        Other Permits Required(under separate application):
        <ejs-checkbox
          label="Building"
          :checked="permit.otherPermitBuilding"
          v-model="permit.otherPermitBuilding"
        />
        &nbsp;
        <ejs-checkbox
          label="Electrical"
          :checked="permit.otherPermitElectrical"
          v-model="permit.otherPermitElectrical"
        />
        <ejs-checkbox
          label="Gas"
          :checked="permit.otherPermitGas"
          v-model="permit.otherPermitGas"
        />
        <ejs-checkbox
          label="PSDS"
          :checked="permit.otherPermitPSDS"
          v-model="permit.otherPermitPSDS"
        />
        <ejs-checkbox
          label="Plumbing"
          :checked="permit.otherPermitPlumbing"
          v-model="permit.otherPermitPlumbing"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContactInfo from "./common/contact-info.vue";
import { emailRule, phoneRule, requiredRule } from "../../../shared/constants";
import { applierTypeEnum } from "./constants";
import AddressInfo from "./common/address-info.vue";
import DateInfo from "./common/date-info.vue";
import { updateContactFieldDS, updateContactNumber, updateContactInfo } from "./helper";
// import SelectMunicipality from "./common/select-municipality.vue";
import { getEServicesContacts } from '../../auth/services/tms-api';

export default {
  name: "ApplicantInfo",
  components: {
    ContactInfo,
    AddressInfo,
    DateInfo,
  },

  data() {
    return {
      phoneRule,
      requiredRule,
      emailRule,
      applier: applierTypeEnum.APPLICANT,
      contactFieldDataSource: null,
      showPermitApplicantValidationError: false,
    };
  },

  created() {
    const { query } = this.$route;
    const { municode } = query;
    const year = new Date().getFullYear().toString().slice(-2);
    // if (username) this.permit.requestor = username;
    if (municode) this.permit.permitNo = `${municode}-${year}-Pending`;
    // eslint-disable-next-line max-len
    if (this.permit && this.permit.applicantCompany && this.permit.applicantCompany.sourceCompanyId) {
      getEServicesContacts(this.permit.applicantCompany.sourceCompanyId)
        .then((res) => {
          // eslint-disable-next-line no-return-assign, no-param-reassign
          res.data.forEach((x) => (x.name = `${x.fName} ${x.lName}`));
          this.contactFieldDataSource = res.data;
        });
    }
  },

  computed: {
    ...mapGetters({
      permit: "permit",
      loggedUser: "loggedUser",
    }),
  },

  // watch: {
  //   loggedUser(user) {
  //     // if (!this.permit.requestor) this.permit.requestor = user.username;
  //   },
  // },

  methods: {
    isSameApplicant() {
      this.permit.isOwnerSameApplicant = this.$refs.owner.$el.checked;
      this.permit.isContractorSameApplicant = this.$refs.contractor.$el.checked;
      this.permit.isEngineerSameApplicant = this.$refs.engineer.$el.checked;

      if (this.showPermitApplicantValidationError) {
        this.showPermitApplicantValidationError = false;
      }
    },
    updateAddress(e) {
      this.permit.applicantCompany = e;
    },
    updateContactNumber(data) {
      updateContactNumber(data, this.permit.applicantContact);
    },
    updateContactFieldDS(dataSource) {
      updateContactFieldDS(this, dataSource, this.permit.applicantContact);
    },
    updateContactInfo(data) {
      updateContactInfo(data, this.permit.applicantContact);
    },
    updateCompanyLegalName(name) {
      this.permit.applicantCompany.legalName = name;
    },
  },
};
</script>
